import React from 'react';
import { Link } from 'react-scroll';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="logo">Nozomi Robotics</div>

        <div className="footer-links">
          <Link to="features" smooth={true} duration={500}>Features</Link>
          <Link to="kit" smooth={true} duration={500}>Kit Details</Link>
          <Link to="research" smooth={true} duration={500}>Research</Link>
          <Link to="how-it-works" smooth={true} duration={500}>How It Works</Link>
          <Link to="contact" smooth={true} duration={500}>Contact</Link>
        </div>

        <p>&copy; {new Date().getFullYear()} Nozomi Robotics. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;